export default "__VITE_ASSET__BjMWj2kl__"